import React from "react";

export interface SlotProps {
    name?: string;
    children?: React.ReactNode;
}

/**
 * Slot component
 *
 * Không render wrapper
 * chỉ return children
 *
 * Dùng để AST giữ structure:
 *
 * {% slot name="endAdornment" %}
 *    ...
 * {% end_slot %}
 *
 */
export default function Slot({
                                 children,
                             }: SlotProps) {
    return <>{children}</>;
}